import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "safira_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

// Resized variant (server-side WebP) for images stored in our API; external URLs untouched.
export const imgUrlW = (url, w) => {
  const u = imgUrl(url);
  if (!u || !/\/api\/(images\/|hero-image)/.test(u)) return u;
  return `${u}${u.includes("?") ? "&" : "?"}w=${w}`;
};

export const errMsg = (e, fallback = "Ralat berlaku. Sila cuba lagi.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
};

export const handleFromUrl = (url, fallback) => {
  if (!url) return fallback;
  const m = url.match(/(?:tiktok\.com|instagram\.com)\/@?([^/?#]+)/i);
  return m ? `@${m[1]}` : fallback;
};
